exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.svg-icon[data-v-c8a70580] {\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.15em;\n  background-color: currentColor;\n  mask-position: center;\n  mask-repeat: no-repeat;\n  mask-size: contain;\n  -webkit-mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-size: contain;\n  overflow: hidden;\n}\n", ""]);

// exports
